import { lazy } from 'react'

export const EventV1 = lazy(() => import('./v1/EventV1'))
export const EventV2 = lazy(() => import('./v2/EventV2'))
